"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
/*
  © 2024 Renishaw plc. All rights reserved.
  This source file is the confidential property and copyright of Renishaw plc.
  Reproduction or transmission in whole or in part, in any form or
  by any means, electronic, mechanical or otherwise, is prohibited
  without the prior written consent of the copyright owner.
*/
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("../styled-components"));
const __1 = require("..");
/** Centre this popup on the page, rather than attaching it to an element as usual */
const PopperWrapper = styled_components_1.default.div `
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 400px;
`;
/** Raised dark panel - custom styling intentionally differs from other popups */
const BodyWrapper = styled_components_1.default.div `
  margin: -17px -10px 3px;
  padding: ${({ theme }) => theme.gutter};
  background: ${({ theme }) => theme.panel};
  box-shadow: ${({ theme }) => theme.boxShadows.standard + "," + theme.boxShadows.highlight};
  border-radius: ${({ theme }) => theme.radius};
`;
/** custom styling intentionally differs from other popups */
const TitleWrapper = styled_components_1.default.div `
  padding: 0 10px;
  font-size: 18px;
  align-items: center;
  display: flex;
  gap: 10px;
`;
/** Customised popup for showing an alert.
 * It displays in the centre of the page, the content is in a raised panel, it has different margins, and larger buttons and header text. */
const MessageBox = ({ open, header, body, footer, onClose, }) => {
    return open ? (react_1.default.createElement(PopperWrapper, { onClick: (evt) => evt.stopPropagation() },
        react_1.default.createElement(__1.PopupLayout, { flat: true, title: react_1.default.createElement(TitleWrapper, null,
                header.icon === "warning" ? (react_1.default.createElement(__1.WarningIcon, { size: 32 })) : header.icon === "info" ? (react_1.default.createElement(__1.Info, { size: 32 })) : header.icon === "error" ? (react_1.default.createElement(__1.AlertError, { size: 32 })) : (""),
                header.heading), primaryActions: footer.buttons.map(({ label, onClick }) => (react_1.default.createElement(__1.Button, { style: { minWidth: 90 }, key: label, onClick: onClick }, label))), onClose: () => onClose() },
            react_1.default.createElement(BodyWrapper, null, body.message)))) : null;
};
exports.MessageBox = MessageBox;
//# sourceMappingURL=index.js.map